import Styles from './Loading.module.scss'
import cx from 'classnames'
import { Text } from 'blaze-ui/Text/Text'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'
import { Check02 } from 'blaze-ui/icons/16'
import { Progress } from './Loading'
import { CSSProperties } from 'react'

interface LoadingProgressesProps {
  progresses: Progress[]
  gap?: number
  finishedLoading?: boolean
}

export const LoadingProgresses = ({ progresses, gap = 16, finishedLoading }: LoadingProgressesProps) => {
  return (
    <div className={Styles.headingsContainer} style={{ gap: `${gap}px` }}>
      {progresses.map((progress, index) => {
        const isRunning = progress.isRunning || progress.percentComplete >= 99
        const isCompleted =
          finishedLoading ||
          (!progress.isRunning && progress.percentComplete === 100 && index !== progresses.length - 1)

        return (
          <div
            className={cx(Styles.progressHeading, {
              [Styles.running]: isRunning,
              [Styles.completed]: isCompleted,
            })}
            key={progress.title}
          >
            <div className={Styles.progressItem}>
              <div
                className={cx(Styles.progressItemCircle, { [Styles.completed]: isCompleted })}
                style={
                  {
                    '--line-height': `${progress.lineHeight || 18}px`,
                  } as CSSProperties
                }
              >
                {isCompleted && <Check02 size={10} color="var(--light-100)" />}
              </div>
              <div className={Styles.textAndElementContainer}>
                <div className={Styles.textContainer}>
                  <Text>{progress.title}</Text>
                  {
                    <div className={cx(Styles.ellipsesContainer, { [Styles.running]: progress.isRunning })}>
                      <LoadingEllipses />
                    </div>
                  }
                </div>
                {progress.element}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
